const connectSocialSteps = [
  {
    id: "connectTwitter",
    title: "Connect Twitter",
    desc: "Connect Twitter account",
    url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=contact",
    iconId: "twitter",
  },
  {
    id: "connectDiscord",
    title: "Connect Discord",
    desc: "Connect Discord account",
    url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=contact",
    iconId: "discord",
  },
  {
    id: "connectLinkedin",
    title: "Connect Linkedin",
    desc: "Connect Linkedin account",
    url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=contact",
    iconId: "linkedin",
  },
  {
    id: "connectFacebook",
    title: "Connect Facebook",
    desc: "Connect Facebook account",
    url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=contact",
    iconId: "facebook",
  },
];

const web3Steps = [
  {
    id: "connectWallet",
    title: "Connect Wallet",
    desc: "Connect web3 wallet",
    url: "/user/wallet#connectwallet",
    iconId:"wallet-icon"
  },
];

export { connectSocialSteps, web3Steps };
